  (function () {
    var root = document.querySelector('[data-fbc]');
    if (!root) return;

    // Mid-article mini card: only on long reads, inserted after ~45% of the
    // top-level paragraphs so it lands between sections rather than mid-thought.
    // rte-formatter re-renders its content on upgrade and can wipe the first
    // insert, so retry until the card is still attached.
    function placeMini() {
      try {
        if (document.querySelector('.fbc-mini')) return;
        // sequential (a grouped selector returns the parent div, which has no <p> children)
        var rte = document.querySelector('.blog-post-content rte-formatter')
          || document.querySelector('.blog-post-content .rte')
          || document.querySelector('.blog-post-content');
        var tpl = document.querySelector('template[data-fbc-mini]');
        if (!rte || !tpl) return;
        var paras = Array.prototype.filter.call(rte.children, function (el) { return el.tagName === 'P'; });
        if (paras.length >= 8) {
          var anchor = paras[Math.floor(paras.length * 0.45)];
          anchor.parentNode.insertBefore(tpl.content.cloneNode(true), anchor);
        }
      } catch (e) { /* the end-of-article card is the fallback */ }
    }
    placeMini();
    setTimeout(placeMini, 1200);
    setTimeout(placeMini, 3000);

    // Klaviyo signup — same client API pattern as the theme's back-in-stock form.
    var form = root.querySelector('[data-fbc-form]');
    var msg = root.querySelector('[data-fbc-msg]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.email.value.trim();
      if (!email || email.indexOf('@') < 1) {
        msg.textContent = 'Please enter a valid email.';
        return;
      }
      var btn = form.querySelector('button');
      btn.disabled = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VaSiHk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Blog CTA',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: { blog_cta_article: root.dataset.fbcArticle || '' }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: 'Ypd6PX' /* New Website Signups (2026) — re-pointed 2026-09-05 */ } } }
          }
        })
      }).then(function (r) {
        if (r.ok || r.status === 202) {
          form.style.display = 'none';
          msg.textContent = 'You’re on the list — watch your inbox.';
        } else {
          btn.disabled = false;
          msg.textContent = 'Something went wrong — please try again.';
        }
      }).catch(function () {
        btn.disabled = false;
        msg.textContent = 'Something went wrong — please try again.';
      });
    });
  })();
